export const DEFAULT_LAYER_COLOR = '#C3C4C6';

// Layer state colors (used in 3D view when CHL/LMN toggled)
export const CHL_COLOR = '#0EA5E9'; // Ocean blue (sky-500) — Can Hold Luminaire
export const LMN_COLOR = '#A3E635'; // Lime-400 — Illuminated (LMN)
export const CHL_LMN_BLEND_COLOR = '#34D399'; // Emerald blend — both CHL + LMN

// Edge border colors
export const LAYER_BORDER_DEFAULT = '#EF4444'; // Red border for clear layer distinction
const LAYER_BORDER_SELECTED = '#ff9136'; // Orange border when selected
export const LAYER_BORDER_HOVERED = '#F87171'; // Brighter red on hover

/** How layers are outlined and highlighted in the 3D view. `hoverFill` / `selectedFill` repaint a
 *  mesh; null leaves its fill and only changes the outline. */
interface LayerHighlightPalette {
  border: string;
  borderHovered: string;
  borderSelected: string;
  hoverFill: string | null;
  selectedFill: string;
}

export const LAYER_HIGHLIGHT_LEGACY: LayerHighlightPalette = {
  border: LAYER_BORDER_DEFAULT,
  borderHovered: LAYER_BORDER_HOVERED,
  borderSelected: LAYER_BORDER_SELECTED,
  hoverFill: '#ff9136',
  selectedFill: '#ef4444',
};

/** Layout v2: neutral outlines and a white selection, so neither clashes with the CHL (blue) and
 *  LMN (lime) fills nor reads as an error. */
export const LAYER_HIGHLIGHT_V2: LayerHighlightPalette = {
  border: '#475569',
  borderHovered: '#CBD5E1',
  borderSelected: '#FFFFFF',
  hoverFill: null,
  selectedFill: '#E2E8F0',
};
